import { LocalizeLanguage } from "./localize-language";

export const LocalizationLanguages : LocalizeLanguage[] = [
    {name: 'English (U.S.)', value: 'en-us'},
    {name: 'Arabic', value: 'ar'},
]